<template>
  <div class="fill-height" :style="[
      {'background-color': `#F4F4F4`} 
    ]">
    <strategio-app-bar></strategio-app-bar>
    <v-main>
      <v-container align-items="center">
        <v-row class="strategio-titles-windows">
          <autoservicio-btn-back title-name="Cargar Bonificaciones"></autoservicio-btn-back>
        </v-row>
        <v-row>
          <v-col cols="4">
            <div @drop.prevent="addDropFile" @dragover.prevent>
              <v-file-input
                class="validation-file-input"
                v-model="file"
                label="File input"
                prepend-icon="mdi-paperclip"
                outlined
                :loading="isLoading"
                :disabled="isLoading"
              >
              </v-file-input>
            </div>            
          </v-col>
          <v-col cols="3" class="d-flex justify-start">
            <v-btn
              :loading="isLoading"
              :disabled="isLoading"
              color="#2262c6"
              class="ma-2 white--text"
              @click="uploadFile"
            >
              Subir archivo
        
              <v-icon right dark> mdi-cloud-upload </v-icon>
        
              <template v-slot:loader>
                <span>Cargando...</span>
                <v-progress-circular
                  indeterminate
                  size="16"
                  color="primary"
                  class="ml-1"
                ></v-progress-circular>
              </template>
            </v-btn>
          </v-col>          
        </v-row>
        <!-- <v-row justify="center" class="pt-10">
          <v-col cols="12">
            <autoservicio-step-validation :items="stepValidation"></autoservicio-step-validation>
          </v-col>
        </v-row> -->
        <!-- <v-row>
          <v-col cols="6">
            <v-skeleton-loader elevation="0" v-if="isLoadingTable"
              type="table"
            ></v-skeleton-loader>
            <custom-bonus-table v-bind="promotions"></custom-bonus-table>
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader elevation="0" v-if="isLoadingTable"
              type="table"
            ></v-skeleton-loader>
            <custom-bonus-table v-bind="bonifications"></custom-bonus-table>
          </v-col>
        </v-row> -->
      </v-container>
    </v-main>
    <custom-snack-bar></custom-snack-bar>
  </div>
</template>
<script>
import StrategioAppBar from '../../../components/header-bar/strategio-app-bar.vue'
import AutoservicioBtnBack from '../../../components/autoservicios/autoservicio-btn-back.vue'
import CustomBonusTable from '../../../components/autoservicios/bonus/custom-bonus-table.vue'
import AutoservicioStepValidation from '../../../components/autoservicios/autoservicio-step-validation.vue'
import CustomSnackBar from '../../../components/snackbars/custom-snack-bar.vue'
import eventBus from '../../../utils/eventBus'
export default {
  name: 'show-bonus-validation',
  components: {
    StrategioAppBar,
    AutoservicioBtnBack,
    AutoservicioStepValidation,
    CustomSnackBar,
    CustomBonusTable
  },
  data () {
    return {
      isLoading: false,
      file: null,
      stepValidation: [
        { step: 1, text: 'Validando formato de archivo', isCompleted: false },
        { step: 2, text: 'Validando bonificaciones', isCompleted: false },
        { step: 3, text: 'Cargando datos', isCompleted: false },
        { step: 4, text: 'Datos cargados', isCompleted: false }
      ],
      promotions: {
      },
      bonifications: {
      },
      isLoadingTable: false
    }
  },
  created () {
    // this.showTables()
  },
  methods: {
    addDropFile (e) {
      this.file = e.dataTransfer.file[0]
    },
    uploadFile () {
      this.stepValidation = this.stepValidation.map(item => ({...item, isCompleted: false}))
      if (!this.file) {
        eventBus.$emit('open-custom-snack-bar', { message: 'Archivo no seleccionado', itsOk: 'warning' })
        return false
      }
      this.isLoading = true
      this.exectuteStep(0)
    },
    exectuteStep (numStep) {
      if (numStep >= this.stepValidation.length) {
        eventBus.$emit('open-custom-snack-bar', { message: 'Archivo cargado con exito', itsOk: 'warning' })
        this.isLoading = false
        this.isLoadingTable = true
        return setTimeout(() => {
          this.isLoadingTable = false
          this.showTables()
        }, 1000)
      }

      return setTimeout(() => {
        this.stepValidation[numStep].isCompleted = true
        this.exectuteStep(numStep + 1)
      }, 1000)
    },
    showTables () {
      let promotions = {
        title: 'Promociones Cargadas',
        items: [
          { marca: 'Babysec', total: 39 },
          { marca: 'Babysec Premium', total: 2 },
          { marca: 'Cotidian Clásico', total: 4 },
          { marca: 'Cotidian Premiun', total: 4 },
          { marca: 'Ladysoft', total: 4 }
        ],
        headers: [{ text: 'Marca', value: 'marca' }, { text: 'Promociones Cargadas', value: 'total' }],
        footers: [{ marca: 'TOTAL', total: 53 }]
      }
      let bonifications = {
        title: 'Bonificaciones Presupuestadas',
        items: [
          { dist: 'demo 01', marca: 'Babysec', qty: 120, total: 1365 },
          { dist: 'demo 01', marca: 'Babysec Premium', qty: 80, total: 4400 },
          { dist: 'demo 01', marca: 'Cotidian Clásico', qty: 60, total: 1680 },
          { dist: 'demo 01', marca: 'Cotidian Premiun', qty: 40, total: 1400 },
          { dist: 'demo 01', marca: 'Ladysoft', qty: 75, total: 1125 }
        ],
        headers: [{ text: 'Distribuidora', value: 'dist' }, { text: 'Marca', value: 'marca' }, { text: 'Cant. Bonificaciones', value: 'qty' }, { text: 'Promociones Cargadas', value: 'total' }],
        footers: [{ marca: 'TOTAL', qty: 375, total: 9970 }]
      }

      this.promotions = promotions
      this.bonifications = bonifications
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/routes/autoservicios/bonus/show-validation.vue